class T_Choice {
  constructor(text, label) {
    this.text = text;
    this.label = label;
  }

  get_text() {
    return this.text;
  }
  get_label() {
    return this.label;
  }
}

class T_Question {
  constructor() {
    this.qid = "";
    this.group = "";
    this.title = "";
    this.text = "";
    this.type = "multiple_choice";
    this.choices = []; // Array of availbale choices
    this.correct = []; // Array of correct choices
    this.max_selection = 100; // Default is mc
    this.min_selection = 1;
    this.weights = [];
    this.P = -1; // Points
    this.P_factor = 1;
    this.moodle_tags = []; // Wird momentan nur für Moodle gebraucht.
    this.moodle_answernumbering = "none";

    // Set during test execution
    this.selected = []; // Array of selected choices ( might contian null values )

    // Helpers for test execution
    this.ok = false;
    this.revisit = false;

   
  }

  /**
   *
   * @param {text} choice_text
   */
  ac(choice_text) {
    let label = "O" + this.choices.length;

    let text;
    if (choice_text.charAt(0) == "*") {
      text = choice_text.substring(1);
      this.correct.push(label);
    } else {
      text = choice_text;
    }
    this.P = this.choices.length;

    this.choices.push(new T_Choice(text, label));

    // Adjust/set the maximum number of points
    this.set_max_points();
  }

  set_max_points() {
    this.P = this.choices.length * this.P_factor
  }

  // https://online-uebungssystem.fernuni-hagen.de/download/XausNBewertung/XausNBewertung.html
  correct_choices() {
    let correct = 0;
    this.choices.forEach((c) => {
      if (this.is_choice_correct(c)) correct++;
    });
    return correct;
  }

  correction() {
    let updated_choices = [];
    let annex = "unset";

    var c;
    this.choices.forEach((choice) => {
      c = choice.label;

      console.log("CHOICE ", c);

      if (this.selected.includes(c) & this.correct.includes(c)) {
        // Richtig getickt
        console.log("A");
        annex = " (ok, " + this.points_for_correct_tick() + ")";
      }

      if (this.selected.includes(c) & !this.correct.includes(c)) {
        // Falscher Tick
        console.log("B");
        annex = " (falsch, " + this.points_for_false_tick() + "P )";
      }

      if (!this.selected.includes(c) & this.correct.includes(c)) {
        // Hätte man ankreuzen sollen
        console.log("C");
        annex = " (wäre richtig gewesen)";
      }

      if (!this.selected.includes(c) & !this.correct.includes(c)) {
        // Falscher Tick
        console.log("D");
        console.log(c);
        console.log(!this.selected.includes(c));
        console.log(!this.correct.includes(c));

        annex = " (ok)";
      }

      updated_choices.push({
        text: choice.text + annex,
        label: choice.label,
        correct: this.is_choice_correct(choice),
      });
    });

    return {
      choices: updated_choices,
      points: this.evaluation(),
      title: this.title,
      P: this.P,
      is_answered: this.is_answered(),
    };
  }

  is_answered() {
    return this.selected.length > 0;
  }

  evaluation() {
    // Eine nicht beantwortete Frage, bekommt immer null Punkte
    if (!this.is_answered()) {
      return 0;
    }

    // Berechne die Anzahl der richtigen Markierungen
    var c = 0;
    var f = 0;
    this.selected.forEach((sel) => {
      if (sel && this.correct.includes(sel)) {
        // Richtiger Tick
        c = c + 1;
      }
      if (sel && !this.correct.includes(sel)) {
        // Richtiger Tick
        f = f + 1;
      }

      console.log("Question : ");
    });

    var points =
      c * this.points_for_correct_tick() + f * this.points_for_false_tick();
    console.log("Question --------- : ", this.text);
    console.log("   c =  ", c);
    console.log("   f =  ", f);
    console.log("   points c =  ", this.points_for_correct_tick());
    console.log("   points f =  ", this.points_for_false_tick());

    if (points < 0) points = 0;
    return points;
  }

  points_for_correct_tick() {
    return this.P / this.correct.length;
  }

  points_for_false_tick() {
    return -this.P / (this.choices.length - this.correct.length);
  }

  evaluation_1() {
    // Eine nicht beantwortete Frage, bekommt immer null Punkte
    if (!this.is_answered()) {
      return 0;
    }

    let N = this.choices.length;
    let c = this.correct_choices();

    // Bei einer 1 aus N Frage m�ssen alle choices korrekt sein
    if (this.max_selection == 1) {
      if (c == N) return this.P;
      else return 0;
    }

    // k aus n Frage. Wir w�hlen die eifache Variante
    // Jede richtige/falsche Anwort ist +-1/P wert, also mit Abz�gen
    return c > N - c ? 2 * c - N : 0;
  }

  point_weights(r) {
    const N = this.choices.length;

    // Alles richtig
    if (r == N) return 1.0;

    // Alles falsch
    if (r == 0) return 0;

    // Bereichne Gewicht
    let f = 1.0;
    for (let i = r + 1; i <= N; i++) {
      f = (f * (i - 2)) / i;
    }
    return f;
  }

  log_points() {
    const N = this.choices.length;
    for (let r = 0; r <= N; r++) {
      console.log(
        r,
        "\t",
        this.point_weights(r),
        "\t",
        this.point_weights(r) * N
      );
    }
  }

  is_choice_correct(choice) {
    let id = choice.label;
    if (
      (this.correct.includes(id) && this.selected.includes(id)) ||
      (!this.correct.includes(id) && !this.selected.includes(id))
    )
      return true;
    else return false;
  }
}

export { T_Question };
